var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.66 12.32 4.304 4.303a.807.807 0 0 1-1.142 1.141l-4.304-4.304a6.4 6.4 0 1 1 1.141-1.14h.001Zm-5.06.88a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6Z",
    fill: "#fff"
  })));
};
export default SvgSearch;